import React, { useEffect, useState } from 'react';


import ProjectGrid from './Komponenty/ProjectGrid';
import SideBar from './Komponenty/SideBar';

/**
 * Renders the ProjectsPage component.
 * 
 * @returns {JSX.Element} The rendered ProjectsPage component.
 */
export default function ProjectsPage() {
    const [filtry, setFiltry] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');

    // wypisz typ filtru, który został wybrany
    const onFiltersChange = (data) => {
        setFiltry(data);
        console.log(data);
    }

    const onSearchChange = (e) => {
        setSearchQuery(e.target.value);
    }

    return (
        <main className='w-full h-full'>
            <div className='flex flex-col flex-1'>
                <SideBar onFiltersChange={onFiltersChange} handleSearch={onSearchChange} />
                <ProjectGrid filters={filtry} searchQuery={searchQuery} />
            </div>
        </main>
    )
}